import React from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'

//UI
import UserForm from '../components/UserForm'

//API
import useUser from '@/features/users/useUser'

//Constant
import { UserRole } from '@/features/users/constants'

const EditUser = () => {
  const { id } = useParams()

  const [searchParams] = useSearchParams()
  const { useUpdateUser, useFetchUser } = useUser()

  const updateUser = useUpdateUser()
  const navigate = useNavigate()
  const { data: user } = useFetchUser(id)

  const type = searchParams.get('type') || user?.role || UserRole.ADMIN

  const onSubmit = async (data) => {
    const newData = {
      ...data,
    }
    delete newData.fullName

    updateUser.mutate(
      { id, data: newData },
      {
        onSuccess: () => {
          navigate(type === UserRole.VENDOR ? '/admin/users/vendors' : '/admin/users/')
        },
        onError: ({ response: { data: errorResponseObj } }) => {
          if (errorResponseObj?.message) {
            toast.error(errorResponseObj?.message)
          }
        },
      }
    )
  }

  return <UserForm onSubmitAction={onSubmit} user={user} type={type} isCreate={false} />
}

export default EditUser
